__turbopack_context__.v({
  "author": "NewsItem-module-sass-module__uidgxG__author",
  "content": "NewsItem-module-sass-module__uidgxG__content",
  "content-announce": "NewsItem-module-sass-module__uidgxG__content-announce",
  "cover-additional": "NewsItem-module-sass-module__uidgxG__cover-additional",
  "cover-main": "NewsItem-module-sass-module__uidgxG__cover-main",
  "date": "NewsItem-module-sass-module__uidgxG__date",
  "favorite": "NewsItem-module-sass-module__uidgxG__favorite",
  "plug": "NewsItem-module-sass-module__uidgxG__plug",
  "restaurants-list": "NewsItem-module-sass-module__uidgxG__restaurants-list",
  "restaurants-title": "NewsItem-module-sass-module__uidgxG__restaurants-title",
  "title": "NewsItem-module-sass-module__uidgxG__title",
  "wrapper": "NewsItem-module-sass-module__uidgxG__wrapper",
});
